/** Skins are token sets in theme/tokens.css, selected by data-skin on <html>. */
export const DEFAULT_SKIN = 'playground';

export function applySkin(skin = DEFAULT_SKIN) {
  // On <html> so the tokens reach <body> (page background) and portals, not only the app container.
  document.documentElement.dataset.skin = skin;
  return skin;
}
